import { Dropdown, DropdownItem, Button } from "acma-spa/dist/buttons";
import { useEffect, useState } from "react";
import { msalSignIn, msalGetOrCreate, msalSubscribe } from "./api/msal";
import { AppProps } from "./AppProps";

export const Header: React.FC<AppProps> = (props) => {
  const [isSignedIn, setIsSignedIn] = useState<boolean>(false);
  const isHomeUrl = window.location.pathname.toLowerCase() === props.homeUrl && window.location.hash != "#/landing";

  const initialise = async () => {
    const msalClient = await msalGetOrCreate(props.b2cDomainName, props.b2cClientId, props.endSessionEndpoint);
    setIsSignedIn(msalClient.getAllAccounts().length > 0);
    msalSubscribe(() => setIsSignedIn(msalClient.getAllAccounts().length > 0));
  }

  useEffect(() => {
    initialise();
  }, []);

  const signIn = async () => {
    const msalClient = await msalGetOrCreate(props.b2cDomainName, props.b2cClientId, props.endSessionEndpoint);
    msalSignIn(props.b2cDomainName, msalClient);
  }

  const signOut = async () => {
    const msalClient = await msalGetOrCreate(props.b2cDomainName, props.b2cClientId, props.endSessionEndpoint);
    const accountList = msalClient.getAllAccounts();
    let account;

    if (accountList.length > 0) {
      account = accountList[0];
    } else {
      account = {};
    }
    const claims = account.idTokenClaims || ({} as any);

    if (claims.authenticationSource !== "socialIdpAuthentication") {
      await msalClient.logoutRedirect({
        postLogoutRedirectUri: props.homeUrl + "#/landing"
      })
    }
    else {
      await msalClient.logoutRedirect();
    }

    setIsSignedIn(false);
  };

  const toggle = () => {
    if (isSignedIn) {
      signOut();
    }
    else if (isHomeUrl) {
      signIn();
    }
    else {
      window.location.href = props.homeUrl;
    }
  };

  return <>
    <div className="input-group input-group-sm d-flex justify-content-end">
      <div className="input-group-append" style={{ width: 400 }}>
        <Button label="Make a payment" className="mt-2 mr-2 mt-sm-0" onClick={() => (window.location.href = "/make-payment")} />
        <div className="ml-auto mt-2 mt-sm-0">
          {!isSignedIn ? <Button label={isSignedIn ? "Logout" : "Login to ACMA Assist"} className="" onClick={() => { toggle(); }} /> :
            <Dropdown label="You're in ACMA Assist">
              <DropdownItem label="Back to ACMA Assist" onClick={() => window.location.href = props.homeUrl} />
              <DropdownItem label="Log out" onClick={() => toggle()} />
            </Dropdown>
          }
        </div>
      </div>
    </div>
  </>
};
